import { Metrics } from './groupMicrobiomeAgeResponse';

export default function sortMetricsByImpact(metrics: Metrics) {
  return (metrics ?? []).sort(
    (a, b) => b.contribution_years - a.contribution_years,
  );
}
